if (not String.prototype.trim?)
  # Make sure we trim BOM and NBSP
  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
  String.prototype.trim = ->
    return this.replace(rtrim, "")
